"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGenerateLineItemsMutation = exports.useFetchLineItemsQuery = exports.billableLineItemApi = void 0;
// api/billableLineItemApi.ts — IF-004.2: read billable line items (used to surface the CORRECTIONAL
// "Corrections" batch on the bill-inspection screen).
var react_1 = require("@reduxjs/toolkit/query/react");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
exports.billableLineItemApi = (0, react_1.createApi)({
    reducerPath: "billableLineItemApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(process.env.LETS_CUE_API),
    tagTypes: ["billableLineItems"],
    endpoints: function (builder) { return ({
        fetchLineItems: builder.query({
            query: function (params) { return ({ url: "/v1/line-items/all", method: "GET", params: params }); },
            providesTags: ["billableLineItems"],
        }),
        generateLineItems: builder.mutation({
            query: function (body) { return ({ url: "/v1/line-items/generate", method: "POST", body: body }); },
            invalidatesTags: ["billableLineItems"],
        }),
    }); },
});
exports.useFetchLineItemsQuery = exports.billableLineItemApi.useFetchLineItemsQuery, exports.useGenerateLineItemsMutation = exports.billableLineItemApi.useGenerateLineItemsMutation;
